import { push }                  from "connected-react-router";
import { getConfigurationValue } from "dmpconnectjsapp-base/helpers/accessors";
import moment                    from "moment";

import PropTypes                                               from "prop-types";
import * as React                                              from "react";
import { useCallback }                                         from "react";
import Button                                                  from "react-bootstrap/Button";
import { connect }                                             from "react-redux";
import { setFindPatientsInsParams, showInsQualificationModal } from "../../dmpconnect/actions";
import { dmpStatuses }                                         from "../../dmpconnect/constants";
import { getBaseName }                                         from "../../dmpconnect/utils/redirect";
import TitleTooltip                                            from "../Common/TitleTooltip";
import AATButton                                               from "../TLSi/AAT/AATButton";
import ALDButton                                               from "../TLSi/ALD/ALDButton";
import DmpAccessButton                                         from "./DmpAccessButton";

const DMPStatusActions = ({
  ins, status, authorization, accessDMP, aldActive, aatActive,
  closingDate, closingMessage, certifiedInsError,
  isTreatingPhysician,
  noButton,
  tlsSubSection,
  selector,
  selectorButtonLabel,
  regulationMode,
  dispatch,
  vitalePatient,
  patientInfos,
  insQualification,
  insQualificationManagement,
  certifiedIdentity,
  aatMode
}) => {
  const searchPatientInsi = useCallback(() => {
    dispatch(setFindPatientsInsParams({
      ...patientInfos,
      birthday: moment(patientInfos.birthday, ["YYYYMMDD", "DD/MM/YYYY"]).format("DD/MM/YYYY")
    }));
    dispatch(push(`${getBaseName(false)}/home/insi-search`));
  }, [ins]);
  
  return (
    <div className="dmp-status-actions">
      {!aatMode && (
        <>
          {certifiedInsError && insQualificationManagement ? (
            <>
              <div>
                <i className="la la-question-circle mr-1" />
                Impossible de récupérer l&apos;identité certifiée
              </div>
              
              <Button size="sm" variant="sand" onClick={() => searchPatientInsi()}>
                <i className="ic-input-search" style={{ fontSize: "14px" }} />
                Rechercher le patient
              </Button>
            </>
          ) : (
            <>
              {!insQualification && insQualificationManagement ? (
                <Button
                  size="sm"
                  variant="sand"
                  onClick={() => dispatch(showInsQualificationModal({ show: true, identity: certifiedIdentity }))}
                >
                  Qualifier l&apos;INS
                </Button>
              ) : (
                <>
                  {selector && status === dmpStatuses.DMPExist && (
                    <Button size="sm" variant="primary" onClick={() => accessDMP(ins)}>
                      {selectorButtonLabel}
                    </Button>
                  )}
                  {!selector && (
                    <DmpAccessButton
                      ins={ins}
                      authorization={authorization}
                      status={status}
                      accessDMP={accessDMP}
                      isTreatingPhysician={isTreatingPhysician}
                      regulationMode={regulationMode}
                    />
                  )}
                  {status === dmpStatuses.DMPIsClosed && (
                    <>
                      <i className="ic-negative mr-2" />
                      <div>
                        <div>
                          DMP fermé depuis le
                          {" "}
                          {moment.utc(closingDate).format("DD/MM/YYYY")}
                          .
                          {" "}
                        </div>
                        <TitleTooltip
                          id={`dmp-closed-reason-${ins}`}
                          text={closingMessage.length > 50 ? closingMessage : undefined}
                        >
                          <div>
                            Raison :
                            {" "}
                            {closingMessage.length > 100 ? `${closingMessage.substring(0, 50)}...` : closingMessage}
                          </div>
                        </TitleTooltip>
                      </div>
                    </>
                  
                  )}
                  {status === dmpStatuses.DMPNotFound && (
                    <span>
                    <i className="ic-question-mark mr-2" />
                    <span>DMP inexistant</span>
                  </span>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
      {!aatMode && aldActive && !noButton && tlsSubSection && <ALDButton subSection={tlsSubSection} />}
      {aatActive && !noButton && tlsSubSection && <AATButton vitalePatient={vitalePatient} dispatch={dispatch} subSection={tlsSubSection} />}
    </div>
  );
};

DMPStatusActions.propTypes = {
  dispatch                  : PropTypes.func.isRequired,
  status                    : PropTypes.number,
  authorization             : PropTypes.number,
  closingDate               : PropTypes.string,
  closingMessage            : PropTypes.string,
  isTreatingPhysician       : PropTypes.bool,
  ins                       : PropTypes.string,
  accessDMP                 : PropTypes.func,
  aldActive                 : PropTypes.bool,
  aatActive                 : PropTypes.bool,
  certifiedInsError         : PropTypes.bool,
  noButton                  : PropTypes.bool,
  tlsSubSection             : PropTypes.string,
  vitalePatient             : PropTypes.object,
  regulationMode            : PropTypes.bool,
  insQualificationManagement: PropTypes.bool,
  aatMode                   : PropTypes.bool,
  insQualification          : PropTypes.object.isRequired,
  certifiedIdentity         : PropTypes.object
};

DMPStatusActions.defaultProps = {
  status                    : null,
  authorization             : null,
  closingDate               : null,
  closingMessage            : null,
  ins                       : null,
  accessDMP                 : null,
  aldActive                 : false,
  aatActive                 : false,
  certifiedInsError         : false,
  isTreatingPhysician       : false,
  noButton                  : false,
  tlsSubSection             : null,
  vitalePatient             : null,
  regulationMode            : false,
  insQualificationManagement: false,
  aatMode                   : false,
  certifiedIdentity         : {}
};

function mapStateToProps (state) {
  const {
          dmpConnectPersistedAppConfiguration
        } = state;
  return {
    insQualificationManagement: getConfigurationValue("insQualificationManagement", dmpConnectPersistedAppConfiguration),
    aatMode                   : getConfigurationValue("aatMode", dmpConnectPersistedAppConfiguration)
  };
}

export default connect(mapStateToProps)(DMPStatusActions);
